import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRouteStopsCombined = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 22 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2904 13.2499C13.2904 13.8577 13.0489 14.4406 12.6192 14.8704C12.1894 15.3001 11.6065 15.5416 10.9987 15.5416C10.3909 15.5416 9.80802 15.3001 9.37824 14.8704C8.94847 14.4406 8.70703 13.8577 8.70703 13.2499C8.70703 12.6421 8.94847 12.0592 9.37824 11.6295C9.80802 11.1997 10.3909 10.9583 10.9987 10.9583C11.6065 10.9583 12.1894 11.1997 12.6192 11.6295C13.0489 12.0592 13.2904 12.6421 13.2904 13.2499Z",
			stroke: "#086ED6",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1514 21.0361C11.8418 21.334 11.4288 21.5004 10.9991 21.5004C10.5695 21.5004 10.1565 21.334 9.84689 21.0361C7.0153 18.2925 3.22122 15.2281 5.07105 10.7786C6.07297 8.37234 8.47464 6.83325 10.9991 6.83325C13.5236 6.83325 15.9262 8.37325 16.9272 10.7786C18.7752 15.2217 14.9903 18.3017 12.1514 21.0361Z",
			stroke: "#086ED6",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2904 45.2499C13.2904 45.8577 13.0489 46.4406 12.6192 46.8704C12.1894 47.3001 11.6065 47.5416 10.9987 47.5416C10.3909 47.5416 9.80802 47.3001 9.37824 46.8704C8.94847 46.4406 8.70703 45.8577 8.70703 45.2499C8.70703 44.6421 8.94847 44.0592 9.37824 43.6295C9.80802 43.1997 10.3909 42.9583 10.9987 42.9583C11.6065 42.9583 12.1894 43.1997 12.6192 43.6295C13.0489 44.0592 13.2904 44.6421 13.2904 45.2499Z",
			stroke: "#FF6D41",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4991 55.3333C16.4991 56.3462 14.037 57.1666 10.9991 57.1666C7.9613 57.1666 5.49914 56.3462 5.49914 55.3333M12.1514 53.0361C11.8418 53.334 11.4288 53.5004 10.9991 53.5004C10.5695 53.5004 10.1565 53.334 9.84689 53.0361C7.0153 50.2925 3.22122 47.2281 5.07105 42.7786C6.07297 40.3723 8.47464 38.8333 10.9991 38.8333C13.5236 38.8333 15.9262 40.3733 16.9272 42.7786C18.7752 47.2217 14.9903 50.3017 12.1514 53.0361Z",
			stroke: "#FF6D41",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 11,
			y1: 23.1001,
			x2: 11,
			y2: 37.1001,
			stroke: "url(#paint0_linear_6358_292942)",
			strokeLinecap: "round",
			strokeDasharray: "2 2"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_6358_292942",
			x1: 10,
			y1: 22.6001,
			x2: 10,
			y2: 37.6001,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#086ED6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF6D41"
			})]
		}) })
	]
});
export default SvgRouteStopsCombined;
